import type { FaireProductEntity } from "../../entity_types/product";

export const p_4bzxyssm4s: FaireProductEntity = {
  token: "p_4bzxyssm4s",
  type: "product",
  name: "Burnisse 18K Gold Non-Tarnish Dainty Chain Necklace",
  brandToken: "b_3tzh9mjdm6",
  brandName: "Flânerie by MAIQ",
  imageUrl:
    "https://cdn.faire.com/fastly/c65fdb06cd1c390698ba083c615df4584cde6d59ffbc7df87d02d7d344fedaed.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1298231671dbf40c958729e8ca10b535ba3c12269efd94d4a4acc61bacc8df88.jpeg",
    "https://cdn.faire.com/fastly/5a456608a0ac0f4d35c5b1d1b9cf9fd3245834d0eb4d68d1a1cf1313b67e15ab.jpeg",
    "https://cdn.faire.com/fastly/2699e7daeeae86540db19171b79aa632cbc444708b2faf1730cbec8a1e38c90f.jpeg",
    "https://cdn.faire.com/fastly/30f7b8c67de5e52ea65089dc457bf8b61401edb1656cd59e9a8dde2b74623f27.jpeg",
    "https://cdn.faire.com/fastly/43ce8bbfca95aa4d0b3858a97b0305fa0cc8cff51b13f401d0d1c29673ec11fc.jpeg",
  ],
  priceDollars: 14.51,
  description:
    "18K Gold Non-Tarnish Dainty Geometric Chain Necklace\n18K Gold Plating\nStainless Steel\nPendant Size (inch): 0.22\nChain Length (inch): 16.53\nExtension(inch): 2\n \n- Lead-free, Nickel-safe\n- Hypoallergenic\n- Water Resistant",
  tags: [],
  msrpDollars: 47.11,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:57:45.232Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
